import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5202831a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "resource-base"
};
const _hoisted_2 = {
  class: "list-warp"
};
const _hoisted_3 = {
  key: 0,
  class: "no-data"
};
import ResourceBaseCard from './ResourceBaseCard.vue';
import SectionContainer from './SectionContainer.vue';
import { Empty } from 'zhs-components';
export default /*#__PURE__*/_defineComponent({
  props: {
    menu: {
      type: Object,
      default: () => ({})
    }
  },

  setup(__props) {
    const $http = inject('$http');
    const resourceBaseList = ref([]);

    const getList = async () => {
      const res = await $http.getInformationResourceBaseList();
      resourceBaseList.value = res;
    };

    const goToPage = url => {
      window.open(url);
    };

    onMounted(() => {
      getList();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(SectionContainer, {
        title: "信息资源基座",
        bg: `linear-gradient(180deg, var(--el-color-primary-light-9) 0%, #fff 42%)`
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resourceBaseList.value.slice(0, 3), item => {
          return _openBlock(), _createBlock(ResourceBaseCard, {
            class: "item",
            title: item.name,
            description: item.description,
            onClick: $event => goToPage(item.target_url)
          }, null, 8, ["title", "description", "onClick"]);
        }), 256))]), resourceBaseList.value.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_unref(Empty), {
          text: "暂无信息资源基座"
        })])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["bg"])]);
    };
  }

});